import React from "react";
import { Modal } from "react-bootstrap";
import { useState } from "react";
import { BsXLg } from "react-icons/bs";
import Swal from "sweetalert2";
import userService from "../../services/user.service";
import SuccessDialog from "../schoolAdminPortal/Popups/SuccessDialog";
import { POPUP_MESSAGE } from "../../utils/constant";
import { useEffect } from "react";
import { CircularProgress } from "@material-ui/core";

const StorageApprovalPopup = ({ rowData, getHoursRequestData }) => {
  const [detailsPopUp, setDetailsPoUP] = useState(false);
  const [approve, setApprove] = useState(false);
  const [disapprove, setdisapprove] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!approve || !disapprove) {
      document.body.style.overflow = "unset ";
    } else {
      document.body.style.overflow = "hidden";
    }
  }, [approve, disapprove]);

  const toggleApproveDialog = () => {
    setApprove(!approve);
    if (approve == false) {
      document.body.style.overflow = "unset ";
    }
  };
  const toggleDisapproveDialog = () => {
    setdisapprove(!disapprove);
    if (!disapprove) {
      document.body.style.overflow = "unset ";
    }
  };
  const handleHoursPopUp = (status) => {
    setDetailsPoUP(status);
  };

  const handleApproveHours = (id) => {
    setLoading(true);
    userService.approveHoursRequest(id).then((data) => {
      if (data.status === 200) {
        setApprove(true);
        getHoursRequestData();
        setDetailsPoUP(false);
        setLoading(false);
      }
    });
  };
  const handleDisApproveHours = (id) => {
    userService.disApproveHoursRequest(id).then((data) => {
      if (data.status === 200) {
        setdisapprove(true);
        getHoursRequestData();
        setDetailsPoUP(false);
        toggleDisapproveDialog();
      }
    });
  };
  return (
    <div>
      {rowData.hoursPurchasedPending !== null &&
      rowData.hoursPurchasedPending !== 0 ? (
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleHoursPopUp(true);
          }}
          className="btn btnpadding buy-btn"
        >
          View Request
        </button>
      ) : (
        "-----"
      )}

      <Modal className="hours-modal" show={detailsPopUp}>
        <Modal.Header className="text-left">
          <div className="d-flex justify-content-between w-100">
            <h6 className="fs-20 semi-bold black">Hours Purchase Request!</h6>
            <BsXLg
              onClick={() => handleHoursPopUp(false)}
              className="crossview cp"
            ></BsXLg>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12 col-md-6 col-lg-6">
              <div className="row p-1">
                <div className="col-12 col-lg-6 col-md-6 fmlabel">
                  <label>School Name</label>
                </div>
                <div className="col-12 col-lg-6 col-md-6 black">
                  <p>{rowData.schoolName}</p>
                </div>
              </div>
              <div className="row p-1">
                <div className="col-12 col-lg-6 col-md-6 fmlabel">
                  <label> Total Hours:</label>
                </div>
                <div className="col-12 col-lg-6 col-md-6 black ">
                  <p className="">{rowData.totalDuration}</p>
                </div>
              </div>

              <div className="row p-1">
                <div className="col-12 col-lg-6 col-md-6 fmlabel">
                  <label>Hours Used:</label>
                </div>
                <div className="col-12 col-lg-6 col-md-6 black">
                  <p>{rowData.usedDuration.toFixed(3)}</p>
                </div>
              </div>

              <div className="clear10"></div>
            </div>
            <div className="col-12 col-md-6 col-lg-6">
              <div className="row p-1">
                <div className="col-12 col-lg-6 col-md-6 fmlabel">
                  <label> School Sport:</label>
                </div>
                <div className="col-12 col-lg-6 col-md-6 black">
                  <p>Football</p>
                </div>
              </div>
              <div className="row p-1">
                <div className="col-12 col-lg-6 col-md-6 fmlabel">
                  <label> Hours Available:</label>
                </div>
                <div className="col-12 col-lg-6 col-md-6 black">
                  <p>{rowData.availableHours.toFixed(3)}</p>
                </div>
              </div>
              <div className="row p-1">
                <div className="col-12 col-lg-6 col-md-6 fmlabel">
                  <label> Request Hours:</label>
                </div>
                <div className="col-12 col-lg-6 col-md-6 black ">
                  <p className="request-hours">
                    {rowData.hoursPurchasedPending}
                  </p>
                </div>
              </div>
            </div>
            <div className="clear20"></div>

            <div className="col-md-6 col-lg-5">
              <div></div>
            </div>
          </div>

          <div className="clear20"></div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className={`${
              !loading ? "saveBtn bgApprove" : "saveBtn bgApprove activv"
            } position-relative d-flex-center blur-filter-background`}
            disabled={loading}
            type="submit"
            onClick={() => handleApproveHours(rowData.id)}
          >
            {loading && (
              <div className="position-absolute d-flex-center blur-filter-background w-100 h-100">
                <CircularProgress size="1.5rem" className="white " />
              </div>
            )}
            {"Approve"}
          </button>

          {/* <button
            onClick={() => handleApproveHours(rowData.id)}
            className="saveBtn bgApprove"
          >
            Approve
          </button> */}
          <button
            onClick={() => handleDisApproveHours(rowData.id)}
            className="saveBtn bgdiApprove"
          >
            DisApprove
          </button>
        </Modal.Footer>
      </Modal>
      <SuccessDialog
        successPopUp={disapprove}
        toggleSuccessDialog={toggleDisapproveDialog}
        msg={POPUP_MESSAGE.hoursRequestdisapprove}
      />
      <SuccessDialog
        successPopUp={approve}
        toggleSuccessDialog={toggleApproveDialog}
        msg={POPUP_MESSAGE.hoursRequestApprove}
      />
    </div>
  );
};

export default StorageApprovalPopup;
